export default __webpack_public_path__ + "static/media/su_logo.4ab71d8c.png";